import { useParams, Navigate } from 'react-router-dom';

export default function ArtefactDetailPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return <Navigate to="/artefacts" replace />;
  return <Navigate to={`/artefacts?tabs=${id}&active=${id}`} replace />;
}
